(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
function initMarqueePause(root) {
  root.querySelectorAll('[data-marquee-pause]').forEach(function(button) {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.addEventListener('click', function() {
      var paused = button.closest('.promo-marquee').classList.toggle('is-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      button.textContent = paused ? '▶' : 'Ⅱ';
    });
  });
}
initMarqueePause(document);
document.addEventListener('shopify:section:load', function(event) { initMarqueePause(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller-gallery"] && !Shopify.designMode) return;
  try {
    
function initYorkshireBestsellers(root) {
  root.querySelectorAll('[data-yp-bestsellers]').forEach(function (section) {
    if (section.dataset.ypReady) return;
    section.dataset.ypReady = 'true';
    var track = section.querySelector('[data-yp-track]');
    var prev = section.querySelector('[data-yp-prev]');
    var next = section.querySelector('[data-yp-next]');
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function move(direction) {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left:step * direction, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initYorkshireBestsellers(document);
document.addEventListener('shopify:section:load', function (event) { initYorkshireBestsellers(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-strip"] && !Shopify.designMode) return;
  try {
    
function initPopularCategories(root) {
  root.querySelectorAll('[data-yp-popular]').forEach(function(section) {
    if (section.dataset.ypReady) return;
    section.dataset.ypReady = 'true';
    var track = section.querySelector('[data-yp-popular-track]');
    var prev = section.querySelector('[data-yp-popular-prev]');
    var next = section.querySelector('[data-yp-popular-next]');
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function move(direction) {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left:step * direction, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function() { move(-1); });
    next.addEventListener('click', function() { move(1); });
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initPopularCategories(document);
document.addEventListener('shopify:section:load', function(event) { initPopularCategories(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mouse hover opens desktop dropdowns; touch and keyboard retain native details controls.
  const hoverTimers = new WeakMap();
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const group = event.target.closest('.yp-nav .yp-browse-group');
    if (!group) return;
    clearTimeout(hoverTimers.get(group));
    document.querySelectorAll('.yp-nav .yp-browse-group[open]').forEach(function (other) {
      if (other !== group) other.open = false;
    });
    group.open = true;
  });
  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse') return;
    const group = event.target.closest('.yp-nav .yp-browse-group');
    if (!group || (event.relatedTarget instanceof Node && group.contains(event.relatedTarget))) return;
    clearTimeout(hoverTimers.get(group));
    hoverTimers.set(group, setTimeout(function () {
      const focused = document.activeElement;
      const keyboardFocusInside = group.contains(focused) && focused.matches(':focus-visible');
      if (!group.matches(':hover') && !keyboardFocusInside) group.open = false;
    }, 160));
  });

  document.addEventListener('click', function (event) {
    const summary = event.target.closest('.yp-nav .yp-browse-group > summary');
    if (summary && event.detail > 0 && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      event.preventDefault();
      summary.parentElement.open = true;
    }
    document.querySelectorAll('.yp-nav .yp-browse-group[open]').forEach(function (group) {
      if (!group.contains(event.target)) group.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.yp-nav .yp-browse-group[open]').forEach(function (group) {
      if (group.contains(document.activeElement)) group.querySelector('summary').focus();
      group.open = false;
    });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.yp-currency[open]').forEach(function (control) {
      if (!control.contains(event.target)) control.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.yp-currency[open]').forEach(function (control) {
      if (control.contains(document.activeElement)) control.querySelector('summary').focus();
      control.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
